// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__23Sj3","sendOtp":"AuthorizeToLogin_sendOtp__15gMe"};